import request from "@/util/auctionRequest";
import request1 from "@/util/request1";
// POST
// ​/hxkj_paimai_server_api​/employAuctionUser​/auctionProjectHomePage
// 拍卖列表分页
export const auctionProjectHomePage = data => {
  return request({
    url: "/employAuctionUser/auctionProjectHomePage",
    method: "post",
    data
  });
};
export const auctionProjectHomePageReflash = data => {
  return request1({
    url: "/employAuctionUser/auctionProjectHomePage",
    method: "post",
    data
  });
};
// 用于首页20秒刷新一次
export const getAllHomePage = data => {
  return request1({
    url: "/employAuctionUser/auctionProjectHomePage",
    method: "post",
    data
  });
};

// GET
// ​/hxkj_paimai_server_api​/employAuctionUser​/auctionProjectDetailsById
// 拍卖项目 - 详情
export const auctionProjectDetailsById = params => {
  return request({
    url: "/employAuctionUser/auctionProjectDetailsById",
    method: "get",
    params
  });
};

// POST
// ​/hxkj_paimai_server_api​/employAuctionUser​/signAuctionUser
// 拍卖用户注册
export const signAuctionUser = data => {
  return request({
    url: "/employAuctionUser/signAuctionUser",
    method: "post",
    data
  });
};

// GET
// ​/hxkj_paimai_server_api​/employAuctionUser​/getCode
// 拍卖用户注册或登录时 - 获取验证码图片
export const getCode = params => {
  return request({
    url: "/employAuctionUser/getCode",
    method: "get",
    params
  });
};

// GET
// ​/hxkj_paimai_server_api​/employAuctionUser​/sendVerificationCode
// 拍卖用户注册时-发送手机验证码
export const sendVerificationCode = params => {
  return request({
    url: "/employAuctionUser/sendVerificationCode",
    method: "get",
    params
  });
};

// POST
// ​/hxkj_paimai_server_api​/employAuctionUser​/auctionUserLogin
// 拍卖客户账号登录
export const auctionUserLogin = data => {
  return request({
    url: "/employAuctionUser/auctionUserLogin",
    method: "post",
    data
  });
};

// GET
// ​/hxkj_paimai_server_api​/employAuctionUser​/verificationImageCode
// 找回密码 -- 验证图形码 并发送短信验证码
export const verificationImageCode = params => {
  return request({
    url: "/employAuctionUser/verificationImageCode",
    method: "get",
    params
  });
};

// get
// ​/hxkj_paimai_server_api​/employAuctionUser​/retrievePasswordGetCode
// 拍卖用户找回密码-获取验证码图片
export const retrievePasswordGetCode = params => {
  return request({
    url: "/employAuctionUser/retrievePasswordGetCode",
    method: "get",
    params
  });
};

// GET
// ​/hxkj_paimai_server_api​/employAuctionUser​/verifySMSNewPassword
// 找回密码 -- 验证短信验证码 并发送短信 账号的新密码
export const verifySMSNewPassword = params => {
  return request({
    url: "/employAuctionUser/verifySMSNewPassword",
    method: "get",
    params
  });
};

// GET
// ​/hxkj_paimai_server_api​/employAuctionUser​/details
// 拍卖客户 -详情
export const employAuctionUserDtails = params => {
  return request({
    url: "/employAuctionUser/details",
    method: "get",
    params
  });
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/getBidRecord
// 查询拍卖出价记录
export const getBidRecord = params => {
  return request1({
    url: "/employAuctionUser/getBidRecord",
    method: "get",
    params
  });
};

// POST​/hxkj_paimai_server_api​/employAuctionUser​/auctionBid
// 拍卖出价
export const auctionBid = data => {
  return request({
    url: "/employAuctionUser/auctionBid",
    method: "post",
    data
  });
};


// GET​/hxkj_paimai_server_api​/employAuctionUser​/details
// 拍卖客户 -详情
export const details = params => {
  return request({
    url: "/employAuctionUser/details",
    method: "get",
    params
  });
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/loginOut
// 退出登录
export const loginOut = params => {
  return request({
    url: "/employAuctionUser/loginOut",
    method: "get",
    params
  });
};

// POST​/hxkj_paimai_server_api​/employAuctionUser​/updateAuctionUser
// 编辑拍卖用户信息
export const updateAuctionUser = data => {
  return request({
    url: "/employAuctionUser/updateAuctionUser",
    method: "post",
    data
  });
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/projectProgressDetail
// 项目进行明细
export const projectProgressDetail = params => {
  return request({
    url: "/employAuctionUser/projectProgressDetail",
    method: "get",
    params
  });
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/auctionSettleDetailsById
// 项目结算 - 详情
export const auctionSettleDetailsById = params => {
  return request({
    url: "/employAuctionUser/auctionSettleDetailsById",
    method: "get",
    params
  }); 
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/getProgressStatusEndTime
// 拍卖项目网站页面 - 获取最新项目状态和最新结束时间
export const getProgressStatusEndTime = params => {
  return request1({
    url: "/employAuctionUser/getProgressStatusEndTime",
    method: "get",
    params,
    isShow: false,
  });
};


// GET​/hxkj_paimai_server_api​/employAuctionUser​/getAuctionAccountPasswordCode
// 获取拍卖账号和密码 - 获取验证码图片
export const getAuctionAccountPasswordCode = params => {
  return request({
    url: "/employAuctionUser/getAuctionAccountPasswordCode",
    method: "get",
    params
  });
};


// GET/hxkj_paimai_server_api​/employAuctionUser​/verificationAuctionAccountCode
// 获取拍卖账号和密码 -- 验证图形码 并发送短信验证码
export const verificationAuctionAccountCode = params => {
  return request({
    url: "/employAuctionUser/verificationAuctionAccountCode",
    method: "get",
    params
  });
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/verifySMSAuctionAccount
// 获取拍卖账号和密码 -- 验证短信验证码 返回账号信息
export const verifySMSAuctionAccount = params => {
  return request({
    url: "/employAuctionUser/verifySMSAuctionAccount",
    method: "get",
    params
  });
};

// GET​/hxkj_paimai_server_api​/employAuctionUser​/getOneselfBid
// 查询自己拍卖出价记录
export const getOneselfBid = params => {
  return request({
    url: "/employAuctionUser/getOneselfBid",
    method: "get",
    params
  });
};


// WEBPACK FOOTER //
// ./src/api/auction/index.js